import './compat';
import Vue from '@vue/compat';
import LoginPanel from './components/LoginPanel.vue';

Vue.component('login', LoginPanel);
